import { DataSource } from "../../Data/DataSource";
import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyObject, PropertyString } from "../../RadObject";
import { ClientAwareCategoryAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareCategoryAttribute";
import { ClientAwareDisplayNameAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareDisplayNameAttribute";
import { WebApiClientService } from "../../Server/WebApiClientService";
import { ServiceManager } from "../../ServiceManager";
import { ComboBox, ComboBoxPropertyValues, IComboBox } from "./ComboBox";
import { NAMESPACE } from "./_Namespace";

export type ComboBoxApiMethodPropertyValues =
    ComboBoxPropertyValues
    & {
        api: string;
        data: any;
        method: string;
    };

export type ComboBoxApiMethodProperties = {
    [name in keyof ComboBoxApiMethodPropertyValues]: Property<ComboBoxApiMethodPropertyValues[name]>
};

export interface IComboBoxApiMethod extends IComboBox, ComboBoxApiMethodProperties
{
}

export class ComboBoxApiMethod extends ComboBox implements IComboBoxApiMethod
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ComboBoxApiMethod";
    public static override className = "ComboBoxApiMethod";

    // #endregion

    // #region Instance

    // #region Properties

    public api!: PropertyString;
    public data!: PropertyObject;
    public method!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ComboBoxApiMethodPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Public Methods

    public async loadDataAsync()
    {
        const
            api = this.api.get(),
            method = this.method.get(),
            data = this.data.get(),
            listData =
                api && method
                    ? await ServiceManager.getRequired(WebApiClientService)
                        .createApiMethodRequest(api, method, data)
                        .executeAsync()
                    : [];

        this.listDataSource.set(new DataSource({ data: listData }));

        this.triggerHandler("listDataSourceChanged");
    }

    // #endregion

    // #region Protected Methods

    protected _dataServiceDataChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _dataServiceIdChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _dataServiceMethodChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ComboBoxApiMethodPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.api =
            new PropertyString(
                this,
                propertyValues.api,
                this._dataServiceIdChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Api" }),
                ]
            );

        this.data =
            new PropertyObject(
                this,
                propertyValues.data,
                this._dataServiceDataChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Data" }),
                ]
            );

        this.method =
            new PropertyString(
                this,
                propertyValues.method,
                this._dataServiceMethodChanged,
                undefined,
                [
                    new ClientAwareCategoryAttribute({ category: "Data" }),
                    new ClientAwareDisplayNameAttribute({ displayName: "Method" }),
                ]
            );
    }

    // #endregion

    // #endregion
}

